module.exports = __webpack_public_path__ + "img/appstore.77ca8b6d.png";